import {HistoryDataSource} from './components/common/history/history.data-source';
import {BulkChangeDataSource} from './components/settings/bulk-change/bulk-change.data-source';
import {CommunicationsReportDataSource} from './components/reports/communications-report/communications-report.data-source';
import {DeliveryRateReportCrudDataSource} from './components/reports/delivery-ratings/delivery-rate.data-source';
import {VehicleChecksFaultsReportCrudDataSource} from './components/reports/vehicle-faults-report/vehicle-checks-faults-report.data-source';
import {VehicleChecksReportCrudDataSource} from './components/reports/vehicle-checks-report/vehicle-checks-report.data-source';
import {DriverPerformanceReportCrudDataSource} from './components/reports/driver-performance/driver-performance-report.data-source';
import {ApiKeysCrudDataSource} from './components/settings/api-keys/api-keys.data-source';
import {NotificationsCrudDataSource} from './components/settings/notification-parameters/notifications.data-source';
import {OrderLogCrudDataSource} from './components/settings/orders/order-log/order-log.data-source';
import {OrderCommunicationsCrudDataSource} from './components/settings/orders/order-communications/order-communications.data-source';
import {VehicleChecksCrudDataSource} from './components/settings/vehicle-checks/vehicle-checks.data-source';
import {AboutCompanyCrudDataSource} from './data-sources/crud/about-company.data-source';
import {DistributionCentreCrudDataSource} from './data-sources/crud/distribution-centre.data-source';
import {DriverCrudDataSource} from './data-sources/crud/driver.data-source';
import {LocationCrudDataSource} from './data-sources/crud/location.data-source';
import {OrderCancellationReasonsCrudDataSource} from './data-sources/crud/order-cancellation-reasons.data-source';
import {OrderItemCancellationReasonsCrudDataSource} from './data-sources/crud/order-item-cancellation-reasons.data-source';
import {OrderCrudDataSource} from './data-sources/crud/order.data-source';
import {SpeedZoneCrudDataSource} from './data-sources/crud/speed-zone.data-source';
import {StateProvinceCrudDataSource} from './data-sources/crud/state-province.data-source';
import {TerritoryGroupCrudDataSource} from './data-sources/crud/territory-group.data-source';
import {TerritoryCrudDataSource} from './data-sources/crud/territory.data-source';
import {UserCrudDataSource} from './data-sources/crud/user.data-source';
import {VehicleRequirementCrudDataSource} from './data-sources/crud/vehicle-requirement.data-source';
import {VehicleTypeCrudDataSource} from './data-sources/crud/vehicle-type.data-source';
import {FuelTypeCrudDataSource} from './components/settings/fuel-types/fuel-type.data-source';
import {VehicleCrudDataSource} from './data-sources/crud/vehicle.data-source';
import {FileAttachmentsDataSource} from './data-sources/file-attachments.data-source';
import {FilterDataSource} from './data-sources/filter.data-source';
import {GeocodingDataSource} from './data-sources/geocoding.data-source';
import {PreferDriverDataSource} from './data-sources/prefer-driver.data-source';
import {OrderItemsDeliveryReportDataSource} from './components/reports/order-items-delivery/order-items-delivery-report.data-source';
import {FuelCostReportCrudDataSource} from './components/reports/fuel-cost/fuel-cost-report.data-source';
import {DailyRunsReportCrudDataSource} from './components/reports/daily-runs/daily-runs-report.data-source';
import {VehicleDriverFilterCrudDataSource} from './components/planning-tool/components/schedule/components/vehicle-driver-filter/vehicle-filter.data-source';
import {OrderStatusesCrudDataSource} from './components/settings/orders/order-statuses.data-source';
import {DriverManifestConfDataSource} from './data-sources/driver-manifest-conf.data-source';
import AppUserCrudDataSource from './components/settings/app-users/app-users.data-source';
import LoadingReportCrudDataSource from './components/reports/loading-report/loading-report.data-source';

export default [
    VehicleCrudDataSource,
    TerritoryCrudDataSource,
    TerritoryGroupCrudDataSource,
    DriverCrudDataSource,
    DistributionCentreCrudDataSource,
    OrderCrudDataSource,
    VehicleRequirementCrudDataSource,
    VehicleTypeCrudDataSource,
    FuelTypeCrudDataSource,
    LocationCrudDataSource,
    SpeedZoneCrudDataSource,
    GeocodingDataSource,
    PreferDriverDataSource,
    FilterDataSource,
    FileAttachmentsDataSource,
    OrderLogCrudDataSource,
    HistoryDataSource,
    UserCrudDataSource,
    AppUserCrudDataSource,
    AboutCompanyCrudDataSource,
    StateProvinceCrudDataSource,
    ApiKeysCrudDataSource,
    OrderCancellationReasonsCrudDataSource,
    OrderItemCancellationReasonsCrudDataSource,
    OrderStatusesCrudDataSource,
    NotificationsCrudDataSource,
    VehicleChecksCrudDataSource,
    OrderCommunicationsCrudDataSource,
    CommunicationsReportDataSource,
    VehicleChecksReportCrudDataSource,
    VehicleChecksFaultsReportCrudDataSource,
    DeliveryRateReportCrudDataSource,
    OrderItemsDeliveryReportDataSource,
    FuelCostReportCrudDataSource,
    DailyRunsReportCrudDataSource,
    VehicleDriverFilterCrudDataSource,
    DriverPerformanceReportCrudDataSource,
    BulkChangeDataSource,
    DriverManifestConfDataSource,
    LoadingReportCrudDataSource
];
